/* dependencies to install in CLI --> must change directory into vendoraccesscorereact project first
    - npm install react react-router-dom buffer
    - npm i --save @fortawesome/fontawesome-svg-core

    # Free icons styles
    npm i --save @fortawesome/free-solid-svg-icons
    npm i --save @fortawesome/free-regular-svg-icons
    npm i --save @fortawesome/react-fontawesome@latest

    # cookies
    npm install js-cookie

    # select that supports pagination on menu scroll
    npm install react-select react-select-async-paginate

    # tabs component
    npm install react-tabs

    # html parser
    npm install html-react-parser 

    # JSONP is a method for sending JSON data without worrying about cross-domain issues.
    npm install fetch-jsonp

    # pdf generator/handler
    npm install react-to-pdf

    # save files locally
    npm install file-saver
*/
import React, { useState } from 'react'
import { Routes, Route, useNavigate } from 'react-router-dom'

import './App.css';

// pages
import Landing from './pages/Landing/Landing'
import Index from './pages/Index/Index'
import ManageAccount from './pages/Account/ManageAccount/ManageAccount'
import ChangePassword from './pages/Account/ChangePassword/ChangePassword'
import ManageProfile from './pages/Account/ManageProfile/ManageProfile'
import RegisterExhibitor from './pages/Account/RegisterExhibitor/RegisterExhibitor'
import ExhibitorSetup from './pages/Account/ExhibitorSetup/ExhibitorSetup'
import AccountsAdmin from './pages/Account/AccountsAdmin/AccountsAdmin'
import LeadCaptureSelect from './pages/LeadCapture/LeadCaptureSelect/LeadCaptureSelect'
import LeadCaptureList from './pages/LeadCapture/LeadCaptureList/LeadCaptureList'
import Home from './pages/Home/Home'
import ForgotPassword from './pages/Home/ForgotPassword/ForgotPassword'
import ResetPassword from './pages/Home/ResetPassword/ResetPassword'
import Logoff from './pages/Landing/Logoff'
import Contact from './pages/Home/Contact/Contact'
import ConfirmSend from './pages/Home/Contact/ConfirmSend'
import GenerateInvoice from './pages/LeadCapture/GenerateInvoice/GenerateInvoice'
import QualifierManager from './pages/LeadCapture/QualifierManager/QualifierManager'
import ExhibitorPasscodes from './pages/LeadCapture/ExhibitorPasscodes/ExhibitorPasscodes'
import ExhibitorLeads from './pages/LeadCapture/ExhibitorLeads/ExhibitorLeads'
// components
/*import Signup from './components/Signup/Signup'*/
import NavBar from './components/NavBar/NavBar'
import LoginForm from './components/Home/LoginForm/LoginForm'
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute'
import LeadCaptureOrder from './components/LeadCapture/LeadCaptureOrder/LeadCaptureOrder'
import ExhibitorConfig from './components/LeadCapture/ExhibitorConfig/ExhibitorConfig'
import PayForm from './components/LeadCapture/LeadCaptureOrder/PayForm'
import Confirmation from './components/LeadCapture/LeadCaptureOrder/Confirmation'
// services
import *  as homeService from './services/homeService'
import *  as accountService from './services/accountService'

const App = () => {
    const navigate = useNavigate()
    const [user, setUser] = useState(homeService.getUser())
    const [role, setRole] = useState([''])
    const handleStopImpersonation = async e => {
        e.preventDefault()
        await  accountService.stopImpersonate();
        // rerender page?
        // force refresh and navigate to index
        //window.location.reload();
        //navigate('/index')
        window.location.href = '/index'
    }
    const handleLogout = () => {
        homeService.logout()
        setUser(null)
        setRole(null)
    }
    const handleSignupOrLogin = () => {
        setUser(homeService.getUser())
    }

    const [message, setMessage] = useState([''])

    const handleChange = e => {
        console.log(e.target.value)
    }
    const updateMessage = msg => {
        setMessage(msg)
    }

    return (
        <>
            <NavBar
                user={user}
                handleLogout={handleLogout}
                handleStopImpersonation={handleStopImpersonation}
            />

            <div
                className={
                    `pageWithNavbarCollapsed`
                }
            >

                <Routes>
                    <Route path="/Login" element={
                        <Landing
                            user={user}
                            handleSignupOrLogin={handleSignupOrLogin}
                            LoginForm={LoginForm}
                            handleChange={handleChange}
                            message={message}
                            setMessage={setMessage}
                            updateMessage={updateMessage}
                        />}
                    />
                    <Route path="/Index" element={
                            <ProtectedRoute user={user}>
                                <Index
                                    user={user}
                                />
                            </ProtectedRoute>
                        }
                    />
                    <Route path="/ManageAccount" element={
                        <ProtectedRoute user={user}>
                            <ManageAccount
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                    />
                    <Route exact path="/RegisterExhibitor/:id/:passcode" element={
                        <RegisterExhibitor
                        />}
                    />
                    <Route exact path="/" element={
                        <LeadCaptureSelect
                        />}
                    />
                    <Route exact path="/LeadCaptureSelect" element={
                        <LeadCaptureSelect
                        />} 
                    />
                    {/*:refNumber(\\d+) -> matches only numbers*/}
                    <Route exact path=":refNumber(\\d+)" element={
                        <LeadCaptureOrder
                        />}
                    />
                    <Route path="/LeadCaptureOrder/:refNumber" element={
                        <LeadCaptureOrder
                        />}
                    />
                    <Route path="/LeadCaptureList" element={
                        <LeadCaptureList
                        />}
                    />
                    <Route path="/ExhibitorConfig/:refNumber(\\d+)" element={
                        <ExhibitorConfig
                        />}
                    />
                    <Route path="/PayForm" element={
                        <PayForm
                        />}
                    />
                    <Route path="/Confirmation" element={
                        <Confirmation
                        />}
                    />
                    <Route path="/Confirmation/:refNumber" element={
                        <Confirmation
                        />}
                    />
                    <Route
                        path="/logoff"
                        element={
                            <Logoff
                                user={user}
                            />
                        }
                    />
                    <Route
                        path="/home"
                        element={
                            <ProtectedRoute user={user}>
                                <Home
                                    user={user}
                                    handleChange={handleChange}
                                />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/changepassword"
                        element={
                            <ProtectedRoute user={user}>
                                <ChangePassword
                                    user={user}
                                    updateMessage={updateMessage}
                                    handleSignupOrLogin={handleSignupOrLogin}
                                />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/forgotpassword"
                        element={
                            <ForgotPassword />
                        }
                    />
                    <Route
                        path="/resetpassword"
                        element={
                            <ResetPassword />
                        }
                    />
                    <Route path="/ManageProfile" element={
                        <ProtectedRoute user={user}>
                            <ManageProfile
                                user={user}
                                updateMessage={updateMessage}
                            />
                        </ProtectedRoute>
                    }
                    />
                    <Route path="/ExhibitorSetup" element={
                        <ProtectedRoute user={user}>
                            <ExhibitorSetup
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                    />
                    <Route path="/AccountsAdmin" element={
                        <ProtectedRoute user={user}>
                            <AccountsAdmin
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                    />
                    <Route path="/Contact" element={
                        <Contact
                        />}
                    />
                    <Route path="/ConfirmSend" element={
                        <ConfirmSend
                        />}
                    />
                    <Route path="/GenerateInvoice" element={
                        <ProtectedRoute user={user}>
                            <GenerateInvoice
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                    />
                    <Route path="/QualifierManager" element={
                        <ProtectedRoute user={user}>
                            <QualifierManager
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                    />
                    <Route path="/ExhibitorPasscodes" element={
                        <ProtectedRoute user={user}>
                            <ExhibitorPasscodes
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                    />
                    <Route path="/ExhibitorLeads" element={
                        <ProtectedRoute user={user}>
                            <ExhibitorLeads
                                user={user}
                            />
                        </ProtectedRoute>
                    }
                    />
                </Routes>
            </div>
        </>
    )
}

export default App